module.exports = __webpack_public_path__ + "static/home_abitarepresenta_old-02779fcbff373d66006b662cf7826b5c.jpg";